module.exports = __webpack_public_path__ + "media/images/login-bfa4a41eaba9e36045daba088c919d51.svg";